var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-api"}},[(_vm.loading)?_c('app-loader',{attrs:{"fixed-on":"desktop"}}):_vm._e(),_c('api-header'),_c('div',{ref:"redoc-container",attrs:{"id":"redoc-container"}}),_c('api-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }